import React from 'react'

const Contact = () => {
  return (
    <div className='pt-24'>Contact</div>
  )
}

export default Contact